module.exports = __webpack_public_path__ + "media/packs/images/flags/IE-ae3eaca8205c648ddc731bfadc853d31.svg";